import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { setApiBaseURL } from '../services/api';

const MarketContext = createContext();

export const MARKETS = [
  {
    id: 'a_stock',
    name: 'A股',
    nameEn: 'A-Stock',
    apiBaseURL: '',
    description: 'A股量化交易平台'
  },
  {
    id: 'chinese_futures',
    name: '期货',
    nameEn: 'Futures',
    apiBaseURL: 'http://localhost:5001',
    description: '中国期货量化交易平台'
  },
  {
    id: 'crypto',
    name: 'Crypto',
    nameEn: 'Crypto',
    apiBaseURL: '',
    description: 'Crypto量化交易平台'
  }
];

export const useMarket = () => {
  const context = useContext(MarketContext);
  if (!context) {
    throw new Error('useMarket must be used within a MarketProvider');
  }
  return context;
};

export const MarketProvider = ({ children }) => {
  const [currentMarketId, setCurrentMarketId] = useState(() => {
    return localStorage.getItem('sagax-market') || 'a_stock';
  });

  const currentMarket = MARKETS.find(m => m.id === currentMarketId) || MARKETS[0];

  const switchMarket = useCallback((marketId) => {
    const market = MARKETS.find(m => m.id === marketId);
    if (!market) return;

    setCurrentMarketId(marketId);
    localStorage.setItem('sagax-market', marketId);
    setApiBaseURL(market.apiBaseURL);
    window.location.reload();
  }, []);

  useEffect(() => {
    setApiBaseURL(currentMarket.apiBaseURL);
    // Drive market-specific CSS vars (e.g. red-up vs green-up convention)
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-market', currentMarket.id);
    }
  }, [currentMarket.apiBaseURL, currentMarket.id]);

  const value = {
    currentMarket,
    markets: MARKETS,
    switchMarket
  };

  return (
    <MarketContext.Provider value={value}>
      {children}
    </MarketContext.Provider>
  );
};
